import { IContact } from '../../model/types'

export const omitUnchangedEmailPixels = ({
  emailPixels,
  ...contact
}: Partial<IContact>): Partial<IContact> =>
  contact.modifiedValues?.includes('emailPixels') ? { ...contact, emailPixels } : contact
